import { useCallback, useEffect } from 'react'

/**
 * Given a keyCode or array of keyCodes, invoke
 * a handler when it is pressed within the window.
 *
 * IMPORTANT: Ensure keyCode and handlers keep referential
 * equality between renders in order to prevent
 * unnecessary triggering
 */
const useWindowKeyDown = (
  keyCode: string | string[],
  handler: (e: KeyboardEvent) => void
) => {
  const handleKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (
        (Array.isArray(keyCode) && keyCode.includes(e.key)) ||
        e.key === keyCode
      ) {
        handler(e)
      }
    },
    [handler, keyCode]
  )

  useEffect(() => {
    if (window) {
      window.addEventListener('keydown', handleKeyDown)
    }

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [handleKeyDown])
}

export default useWindowKeyDown
